import React, { Fragment, useEffect, useState } from "react";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import style from "./content.module.css";
import SideNav from "./SideNav/SideNav";
import ProfileLogout1 from "./ProfilePopup/ProfileLogout1";
import SelectCompany from "./SelectCompany/SwitchCompany";
import { jwtDecode } from "jwt-decode";
import store from "../Store/Store";
// import { useIntercom } from "../Intercom.js";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { observer } from "mobx-react";
import config from "../config/config";

const Content = observer(() => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [clicked, setClicked] = useState(false);
  const [clicked1, setClicked1] = useState(false);
  const [switchcom, setswitchcom] = useState(false);
  const [auth, setAuth] = useState("");
  const aid = searchParams.get("aid");

  // const UpdateIntercom = async () => {
  //   console.log("UPDATING INTERCOM USER DATA");
    
  //   let tokens = localStorage.getItem("authToken");
  //   let parsedTokens = JSON.parse(tokens);
  //   try {
  //     const expired = isTokenExpired(
  //       parsedTokens?.IdToken ? parsedTokens?.IdToken : "",
  //     );
  //     if (!expired) {
  //       console.log("tokens",tokens);
        
  //       let decodeToken = jwtDecode(parsedTokens.IdToken);
  //       console.log("decodeToken",decodeToken);
        
  //       let user_id = decodeToken["sub"];
  //       let name = decodeToken["name"];
  //       let email = decodeToken["email"];
  //       let created_at = decodeToken["custom:create_at"];
  //       let user = {
  //         app_id: "or8u1ybp",
  //         id: user_id,
  //         name: name,
  //         email: email,
  //         created_at: created_at,
  //         rail: store.userType == "PineLabUser"?"Pinelabs":"Axis"
  //       };
  //       console.log("user-------->", user);

  //       useIntercom(user);
  //     }
  //   } catch (err) {
  //     console.log("error", err);
  //   }
  // };

  // useEffect(() => {
  //   UpdateIntercom();
  // }, [store.refresh]);


  console.log("aid--->", store.Company_Id);

  const handelClick = () => {
    if (clicked) {
      setClicked(false);
      return;
    }
    setClicked(true);
  };

  const handelClick1 = () => {
    if (clicked1) {
      setClicked1(false);
      return;
    }
    setClicked1(true);
  };

  const getUsersAccess = async (compid) => {
    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);
    let token = parsedTokens?.IdToken;
    let getNewTokens = jwtDecode(token);
    let ownerAccess = getNewTokens["custom:cupi_owner"];
    ownerAccess = ownerAccess ? ownerAccess : [];
    let AdminAccess = getNewTokens["custom:cupi_admin"];
    AdminAccess = AdminAccess ? AdminAccess : [];
    let ViewAdminAccess = getNewTokens["custom:cupi_view_admin"]; //View Admin
    ViewAdminAccess = ViewAdminAccess ? ViewAdminAccess : [];
    console.log(getNewTokens["custom:es_view_admin"]);
    let GlobalViewAdmin = getNewTokens["custom:es_view_admin"] == "true"; //Global View Admin
    GlobalViewAdmin = GlobalViewAdmin ? GlobalViewAdmin : [];
    let isEsAdmin = getNewTokens["custom:es_admin"] == "true";
    const userOwnerAccess = ownerAccess.includes(compid);
    const userAdminAccess = AdminAccess.includes(compid);
    const userViewAdminAccess = ViewAdminAccess.includes(compid);

    if (userViewAdminAccess) {
      store.setIsUserViewAdmin(true);
      console.log("===============this user is a View Admin===============");
    } else {
      store.setIsUserViewAdmin(false);
    }

    if (GlobalViewAdmin) {
      console.log(
        "===============this user is a Global View Admin===============",
      );
      store.setIsUserGlobalViewAdmin(true);
    } else {
      store.setIsUserGlobalViewAdmin(false);
    }

    if (userAdminAccess) {
      console.log("===============this user is a Admin===============");
      store.setIsUserAdmin(true);
      store.setIsUserViewAdmin(false);
      store.setIsUserGlobalViewAdmin(false);
    } else {
      store.setIsUserAdmin(false);
      console.log("Not A Admin");
    }

    if (userOwnerAccess) {
      console.log("===============this user is a OWNER===============");
      store.setIsUserAdmin(true);
      store.setIsUserOwner(true);
      store.setIsUserViewAdmin(false);
      store.setIsUserGlobalViewAdmin(false);
    } else {
      store.setIsUserOwner(false);
      console.log("Not A Owner");
    }

    if (isEsAdmin) {
      console.log("===============this user is a ES ADMIN===============");
      store.setIsUserAdmin(true);
      store.setIsUserOwner(true);
      store.setIsUserViewAdmin(false);
      store.setIsUserGlobalViewAdmin(false);
    }
  };

  useEffect(() => {
    getUsersAccess(store?.Company_Id);
    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      navigate("/login");
      return;
    }

    const parsedAuth = JSON.parse(authToken);
    setAuth(parsedAuth);

    verifyTokens(parsedAuth);

    if (location.pathname === "/content") {
      navigate("/content/transactions");
    }
  }, [navigate, location.pathname, store.refresh]); // Dependencies ensure this runs correctly

  const verifyTokens = (authData) => {
    if (!authData || !authData.IdToken) {
      navigate("/login");
      return;
    }

    const expired = isTokenExpired(authData.IdToken);

    if (expired) {
      getNewTokens(authData);
    }
  };

  const getNewTokens = async (authData) => {
    if (!authData?.RefreshToken) {
      localStorage.removeItem("authToken");
      navigate("/login");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData?.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData?.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
        setAuth(newAuthToken); // Update state
        if (store.refresh) {
          store.setRefresh(false);
        } else {
          store.setRefresh(true);
        }
      } else {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    } catch (error) {
      console.log("Error refreshing tokens:", error);
      localStorage.removeItem("authToken");
      navigate("/login");
    }
  };

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      console.log("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

  return (
    <div
      className={style.container}
      onClick={() => {
        setClicked(false);
        setClicked1(false);
      }}
    >
      <div className={style.sidenav}>
        <SideNav
          closeTabs={() => {
            setswitchcom(false);
          }}
        />
      </div>
      <div className={style.containmainClass}>
        <div className={style.topbar}>
          <div className={style.welcomesunshineinfotechWrapper}>
            <div className={style.welcomesunshineinfotech}>
              {store.companyName}
            </div>
          </div>

          <button
            className={style.ImageContainer}
            onClick={(e) => {
              e.stopPropagation();
              setClicked(false);
              handelClick1();
            }}
          >
            <img
              alt=""
              src={"/CustomerSupportVector.svg"}
              className={style.userProfile}
            />
            {clicked1 && (
              <div
                className={style.popupcontainer}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <div className={style.popupcontainer1}>
                  <div className={style.popupcontainer1HeaderContainer}>
                    <div className={style.popupcontainer1Header}>
                      Need Help?
                    </div>
                  </div>
                  <div className={style.popupcontainerContent}>
                    <div className={style.popupcontainerone}>
                      <img
                        alt=""
                        src={"/gmailLogo.svg"}
                        className={style.userProfile1}
                      />{" "}
                      <p> {"Email us: care@getcupi.com"}</p>
                    </div>
                    <div className={style.popupcontainerone}>
                      {" "}
                      <img
                        alt=""
                        src={"/Phone.svg"}
                        className={style.userProfile1}
                      />
                      Call us: +91 9740510088
                    </div>
                    <div className={style.popupcontainerone}>
                      <img
                        alt=""
                        src={"/gmail.svg"}
                        className={style.userProfile1}
                      />
                      We are here for you from Monday - Saturday, 10am to 7pm.
                    </div>
                  </div>
                </div>
              </div>
            )}
          </button>

          <button
            className={style.ImageContainer}
            onClick={(e) => {
              e.stopPropagation();
              handelClick();
              setClicked1(false);
            }}
          >
            <img
              alt=""
              src={"/user-circle.svg"}
              className={style.userProfile}
            />
            {clicked && (
              <div
                className={style.popupcontainer}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <ProfileLogout1
                  isVisible={clicked}
                  onclose={() => {
                    setClicked(false);
                  }}
                  SwitchComp={() => {
                    setswitchcom(true);
                  }}
                />
              </div>
            )}
          </button>
        </div>
        <div className={style.contentmain}>
          <Outlet />
        </div>
      </div>
      {switchcom && (
        <button
          className={style.containSelectComp}
          onClick={() => {
            setswitchcom(false);
          }}
        >
          <SelectCompany
            onclose={() => {
              setswitchcom(false);
            }}
            isVisible={switchcom}
            onclosepopup={() => {
              setClicked(false);
            }}
          />
        </button>
      )}
    </div>
  );
});

export default Content;
